import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=40ff0b1a&scoped=true"
var script = {}
import style0 from "./Drawer.vue?vue&type=style&index=0&id=40ff0b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff0b1a",
  null
  
)

export default component.exports